/* eslint-disable */

module.exports = Object.freeze({
    REGEX: {
        LETTERS_NUMBERS_UNDERSCORE_DASH: "([A-Za-z0-9\-\_]+)",
        NUMBERS_ONLY: "^\\d+$",
        EMAIL: "(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)",
        LETTERS_NUMBERS_ONLY: "(^(?!\s*$).+)",
        PHONE_WITH_EXTENSION: "(^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(x\d{2,4})?$)"
    }
});


// WEBPACK FOOTER //
// ./src/components/Common/Constants/Constants.js